import { gameAssets, handleGameState, instances, parseJackpotResult, pendingGameUpdate, setBet, setSessionExpired, setTotalRound, showErrorPopup, showGrandJackpotWin, showMajorJackpotWin, showManualPopup, showMinorJackpotWin, updateBalance, updateTotalBet } from "./gameUI";
import tuktukDemoState, { globalData } from "./globalData";
import axios from 'axios';
import { getTotalBet } from "./betPanel";
import { gameStates } from "./gameStates";
import { generateClientSeed } from "../../../utils/common.helper";
import { demoData, placeBetSimulator, updateDemoRoundDetails } from "./demoSimulator";

export let connected = false;

let placingBet = false;
// export function checkConnection() {
//     if (connected) return true;
//     else false
// }

export async function createConnection(baseUrl) {
    globalData.baseUrl = baseUrl;

    if (tuktukDemoState.isDemo) {
        getDemoGameData()
        return;
    }
    // sendPostRequest(globalData.userCode, globalData.currencyCode)
    if (
        globalData.currencyCode &&
        globalData.operatorId &&
        globalData.accessToken &&
        globalData.gameCode
    ) {
        // getJwtToken()
    }
    else {
        // console.error(`Error in currencyCode: ${globalData.currencyCode}, operatorId: ${globalData.operatorId}, accessToken: ${globalData.accessToken} or gameCode: ${globalData.gameCode}`)
    }
}

async function sendPostRequest(userCode, currencyCode) {

    const data = {
        "userCode": "USER001",
        "currencyCode": "PHP"
    }

    await axios.post(`${process.env.REACT_APP_BACKEND_URL_HTTP}/auth/login`, data)
        .then((response) => {
            storeAndFetchAccessToken(response.data);
        })
        .catch((error) => {
            if (error.response?.data.errors[0].name == "InvalidToken") {
                errorOccured(error.message)
                globalData.tokenExpired = true
                setSessionExpired();
            }
            // console.error('Error during POST request:', error);
        });
}

function storeAndFetchAccessToken(data) {
    globalData.accessToken = data.accessToken
    initialize(globalData.accessToken)
}



export async function initialize(accessToken) {
    getJwt(accessToken);
    //  storeLoginResponse(data);
}

export async function getJwt() {
    const data = {
        currencyCode: globalData.currencyCode,
        operatorId: globalData.operatorId,
        operatorUserToken: globalData.accessToken,
        gameId: globalData.gameCode
    }
    try {
        if (globalData.response) {
            // let res = JSON.parse(window.atob(sessionStorage.getItem('tk')))
            storeLoginResponse(globalData.response);
        }
        // else {
        //     await axios.post(globalData.baseUrl + '/user/login', data)
        //         .then((response) => {
        //             console.log('Data received here jwt:', response.data);
        //             storeLoginResponse(response.data);
        //         })
        //         .catch((error) => {
        //             if (error.response?.data.errors[0].name == "InvalidToken") {
        //                 errorOccured(error.message)
        //             }
        //             console.error('Error during POST request:', error);
        //             //  error = true
        //         });
        // }
    } catch (error) {
        // console.error(error)
    }
}


function storeLoginResponse(data) {
    globalData.userId = data.data.user.id;
    globalData.gameLanguage = data.data.user.language;
    //  console.log("game language:", data.data.user.language);
    if (!globalData.jwtToken) globalData.jwtToken = data.data.accessToken;

    globalData.balance = data.data.wallet.balance

    globalData.showAutoAndTurbo = data.data.gameSettings.enableAutoplayTurbo;
    globalData.betSettings = data.data.gameSettings.validBetArray
    globalData.betSettings.sort((a, b) => a - b);
    //  console.log("bet settings:", globalData.betSettings)

    globalData.minBet = data.data.gameSettings.minBet.PHP
    globalData.betMultiplier = data.data.gameSettings.betValue
    globalData.maxBet = data.data.gameSettings.maxBet.PHP

    globalData.isNewUser = data.data.isNewUser

    globalData.roundSettings = data.data.gameSettings.numberOfRounds;
    globalData.roundSettings.sort((a, b) => a - b);

    globalData.isJackpotActive = data.data.gameSettings.isJackpotActive
    if (data.data.gameSettings.jackpotDetails.JackpotTiers) {
        //  console.log("Jackpot", data.data.gameSettings.jackpotDetails);
        globalData.grandCurrentJackpotValue = data.data.gameSettings.jackpotDetails.JackpotTiers[2].currentValue
        globalData.majorCurrentJackpotValue = data.data.gameSettings.jackpotDetails.JackpotTiers[0].currentValue
        globalData.minorCurrentJackpotValue = data.data.gameSettings.jackpotDetails.JackpotTiers[1].currentValue
        // console.log("jackpot details", globalData.grandCurrentJackpotValue, " ", globalData.majorCurrentJackpotValue, " ", globalData.minorCurrentJackpotValue)
    }
    else {
        console.log("no JackpotTiers details");
        //  globalData.jackpot = false;
    }

    //   console.log('Data received here:', globalData.minBet, globalData.maxBet, globalData.roundSettings);
    if (gameAssets?.balanceValueText?.text) gameAssets.balanceValueText.text = data.data.wallet.balance
    connected = true;
    // console.log(globalData.jwtToken, " jwt token")
}

//TODO: PLACE BET FROM HERE
export async function finalizeRoundBet() {
    if (!placingBet) {
        placeBet();
        placingBet = true;
    } else {
    }
}

async function placeBet() {
    axios.defaults.headers.Authorization = `bearer ${globalData.jwtToken}`;
    const totalBet = getTotalBet();

    if (tuktukDemoState.isDemo) {
        placeBetDemoGame(globalData.totalRounds, totalBet);

        setTimeout(() => {
            placingBet = false;
        }, 1000);
        return;
    }

    const data = {
        clientSeed: generateClientSeed()?.seed,
        noOfRounds: globalData.totalRounds,
        betAmount: totalBet ? totalBet : 10,
    };

    // Set a timeout for 2 seconds to show the loader
    const loaderTimeout = setTimeout(() => {
        instances.NetworkLoader?.showLoader();
    }, 1500);

    try {
        const response = await axios.post(globalData.baseUrl + '/game/lottery/tuk-tuk-gold/place-bet', data);

        // If the response comes before 2 seconds, prevent showLoader and call hideLoader
        clearTimeout(loaderTimeout);
        instances.NetworkLoader?.hideLoader()

        continueWithBetResult(response.data);

        setTimeout(() => {
            placingBet = false;
        }, 2000);
    } catch (error) {
        // Clear the timeout so showLoader isn't called if an error happens quickly
        clearTimeout(loaderTimeout);
        instances.NetworkLoader?.hideLoader()

        gameAssets.timerTween.visible = false;
        if (gameAssets.timerTween.length) {
            gameAssets.timerTween.forEach(tween => tween.kill());
            gameAssets.timerTween.length = [];
        }

        if (error?.response?.data?.errors[0]?.description === 'USER_IS_BLOCKED') {
            showManualPopup('USER BLOCKED','user is blocked please contact admin')
            return;
        } else if (error?.response?.data.errors[0]?.description == "INVALID_TOKEN") {
            globalData.tokenExpired = true;
            showErrorPopup("Access token expired")
            setTimeout(() => {
                setSessionExpired();
            }, 1200);
            //  errorOccured(error.message);
            return;
        } else if (error?.response?.data.errors?.[0]?.fields?.message === 'jwt expired') {
            globalData.tokenExpired = true;
            showErrorPopup('Token Expired')
            setTimeout(() => {
                setSessionExpired();
            }, 1200);
        }
        else if (error?.response?.data?.errors[0]?.description == "PREVIOUS_BET_NOT_COMPLETED") {
            showErrorPopup("PREVIOUS BET NOT COMPLETED");
            return;
        }
        else if (!error.response) {
            //showErrorPopup("Network error! Please check your connection.");
            showErrorPopup(error.response?.data.errors[0]?.description);
            await waitForNetwork();
            await placeBet();
        }
    }
}
function continueWithBetResult(data) {
    globalData.balance = data.data.wallet.balance ? data.data.wallet.balance : null;
    // console.log("balance api:", data.data.wallet.balance)
    updateBalance();
    handleGameState(globalData.currentGameState);
    // if (data.data.jackpotDetails.length > 0) {
    //     handleJackpotDetails(data.data.jackpotDetails)
    //     handleJackpotPanel(data.data.jackpotDetails)
    // }
    // else globalData.jackpot = false;
    // if (gameAssets?.balanceValueText?.text) gameAssets.balanceValueText.text = data.data.wallet.balance
    if (gameAssets.cheatMessage.text) gameAssets.cheatMessage.text = data.data.details.obstaclesDirection
}
export function settuktukJackpotDataWs(data, userId) {
    if (userId == globalData.userId) {
        handleJackpotDetails(data)
        handleJackpotPanel(data)
    }
    else {
        handleJackpotDetails(data);

        globalData.grandCurrentJackpotValue = data[2].data.currentValue;
        globalData.majorCurrentJackpotValue = data[0].data.currentValue;
        globalData.minorCurrentJackpotValue = data[1].data.currentValue;

        globalData.resetGrandJackpotValue = data[2].data.jackpotBeforeTrigger;
        globalData.resetMajorJackpotValue = data[0].data.jackpotBeforeTrigger;
        globalData.resetMinorJackpotValue = data[1].data.jackpotBeforeTrigger;

        if (!globalData.jackpotGrandWin) {
            showGrandJackpotWin(globalData.grandCurrentJackpotValue, 4);
        } else {
            showGrandJackpotWin(globalData.resetGrandJackpotValue, 4);
        }

        if (!globalData.jackpotMajorWin) {
            showMajorJackpotWin(globalData.majorCurrentJackpotValue, 4);
        } else {
            showMajorJackpotWin(globalData.resetMajorJackpotValue, 4)
        }

        if (!globalData.jackpotMinorWin) {
            showMinorJackpotWin(globalData.minorCurrentJackpotValue, 4)
        } else {
            showMinorJackpotWin(globalData.resetMinorJackpotValue, 4)
        }
    }
}
function handleJackpotPanel(jackpotDetails) {
    globalData.grandCurrentJackpotValue = jackpotDetails[2].data.currentValue;
    globalData.majorCurrentJackpotValue = jackpotDetails[0].data.currentValue;
    globalData.minorCurrentJackpotValue = jackpotDetails[1].data.currentValue;

    globalData.resetGrandJackpotValue = jackpotDetails[2].data.jackpotBeforeTrigger;
    globalData.resetMajorJackpotValue = jackpotDetails[0].data.jackpotBeforeTrigger;
    globalData.resetMinorJackpotValue = jackpotDetails[1].data.jackpotBeforeTrigger;


    showMinorJackpotWin(globalData.jackpotMinorWin ? globalData.jackpotMinorWinAmount : globalData.minorCurrentJackpotValue, 4);
    showMajorJackpotWin(globalData.jackpotMajorWin ? globalData.jackpotMajorWinAmount : globalData.majorCurrentJackpotValue, 4);
    showGrandJackpotWin(globalData.jackpotGrandWin ? globalData.jackpotGrandWinAmount : globalData.grandCurrentJackpotValue, 4);
}

function handleJackpotDetails(jackpotDetails) {
    // console.log("wehdhjewbfhewbfhb", jackpotDetails[0].data.wonAmount);
    globalData.jackpotDetails = jackpotDetails

    globalData.jackpotMinorWin = globalData.minorFlag = jackpotDetails[1].data.won
    globalData.jackpotMajorWin = globalData.majorFlag = jackpotDetails[0].data.won
    globalData.jackpotGrandWin = globalData.grandFlag = jackpotDetails[2].data.won

    globalData.jackpotMinorWinAmount = jackpotDetails[1].data.wonAmount
    globalData.jackpotMajorWinAmount = jackpotDetails[0].data.wonAmount
    globalData.jackpotGrandWinAmount = jackpotDetails[2].data.wonAmount

    parseJackpotResult();
}

export async function betHistory() {

    if (tuktukDemoState.isDemo) {
        return;
    }

    axios.defaults.headers.Authorization = `Bearer ${globalData.jwtToken}`;

    await axios.get(process.env.REACT_APP_BACKEND_URL_HTTP + `/user/bet-history?page=1&perPage=10&gameId=${globalData.gameCode}`)
        .then((response) => {
            const tempArray = response?.data?.data?.rows?.map(({ car_direction, bet_amount, createdat, result, obstacles_direction, winning_amount, beforebalance, afterbalance, prize_upgrade }) => {
                const dateObj = new Date(createdat);

                const date = dateObj.toLocaleDateString('en-CA');
                const time = dateObj.toLocaleTimeString('en-GB');

                return {
                    car_direction,
                    bet_amount,
                    result,
                    date,
                    time,
                    obstacles_direction,
                    winning_amount,
                    beforebalance,
                    afterbalance,
                    prize_upgrade
                };
            });

            console.log("RESPONSE BET HISTORY", tempArray);
            globalData.betHist = tempArray;

            if (tempArray.length) instances.MenuPopUp.populateRows();
            return;

        }).catch((error) => {
            console.log("BET HISTORY API ERROR", error, error?.response?.data?.errors[0]?.description, error?.response?.data?.errors[0]?.fields?.message);

            if (error?.response?.data?.errors[0]?.description == 'Either access token not passed or it is expired' || error?.response?.data?.errors[0]?.fields?.message == 'jwt expired') {
                showErrorPopup('Token Expired!');
                return;
            }
            showErrorPopup("Network Error");
        })
}

export async function playGame() {

    if (tuktukDemoState.isDemo) {
        playGameDemo(globalData.jeepneyLane);
        return;
    }

    axios.defaults.headers.Authorization = `Bearer ${globalData.jwtToken}`;


    const data = {
        carPos: globalData.jeepneyLane
    };

    // Set a timeout to show the loader after 2 seconds
    const loaderTimeout = setTimeout(() => {
        instances.NetworkLoader?.showLoader();
    }, 2000);

    // Function to attempt the API call with retry logic
    async function attemptPlayGame() {
        try {
            const response = await axios.post(`${globalData.baseUrl}/game/lottery/tuk-tuk-gold/play-game`, data);

            // If the response comes before 2 seconds, prevent showLoader and call hideLoader
            clearTimeout(loaderTimeout);
            instances.NetworkLoader?.hideLoader();

            storeRoundResult(response.data);
        } catch (error) {
            // Clear the timeout so showLoader isn't called if an error happens quickly
            clearTimeout(loaderTimeout);
            instances.NetworkLoader?.hideLoader();

            gameAssets.timerTween.visible = false;
            if (gameAssets.timerTween.length) {
                gameAssets.timerTween.forEach(tween => tween.kill());
                gameAssets.timerTween.length = [];
            }

            if (!error.response) {
                // Network-related error
                // console.error("Network error occurred:", error.message);
                showErrorPopup("Network error! Please check your connection.");

                await waitForNetwork();

                // Retry the operation
                await attemptPlayGame(); // Recursive retry
            } else {
                // Handle other errors 
                const errorMessage = error.response?.data.errors?.[0]?.description || "An error occurred.";
                // console.error("Error during POST request:", error.response);
                showErrorPopup(errorMessage);

                if (error.response?.data.errors?.[0]?.name === "InvalidToken") {
                    //  errorOccured(error.message);
                    globalData.tokenExpired = true;
                    showErrorPopup("Access token expired")
                }
            }
        }
    }

    await attemptPlayGame();
}
// Utility function to wait for network restoration
function waitForNetwork() {
    return new Promise((resolve) => {
        function checkNetwork() {
            if (navigator.onLine) {
                // Network is back online
                instances.PopUpMessage.closePopUp()
                window.removeEventListener('online', checkNetwork);
                resolve();
            }
        }

        // Add an event listener to detect when the network is back
        window.addEventListener('online', checkNetwork);

        // Optionally, check the network periodically
        const interval = setInterval(() => {
            if (navigator.onLine) {
                clearInterval(interval);
                instances.PopUpMessage.closePopUp()
                window.removeEventListener('online', checkNetwork);
                resolve();
            }
        }, 1000);
    });
}



function storeRoundResult(data) {
    globalData.totalRounds = data.data.details.maxRound;
    globalData.obstacleLane = data.data.obstaclePos;
    globalData.gameResult = data.data.details.result;
    globalData.roundWinnings = data.data.details.winningAmount;
    if (globalData.roundWinnings > 0) {
        globalData.balance = data.data.wallet.balance;
        updateBalance();
    }

    globalData.multiplier = data.data.details.roundDetails[data.data.details.roundDetails.length - 1].awardMulti;
    globalData.winType = data.data.details.typeOfWin;
    globalData.prizeUpgrade = data?.data?.awardUpgrade
    // globalData.jackpot  = 
    handleGameState(globalData.currentGameState);
    // if (gameAssets?.balanceValueText?.text && data?.data?.wallet?.balance) gameAssets.balanceValueText.text = data.data.wallet.balance
}

export async function checkForPendingGame() {
    if (!tuktukDemoState.isDemo)
        checkForToken();
    else
        startNewGame()
    //   handleGameState(gameStates.IDLE)
}
let networkCounter = 0;
const waitTime = 75;
let error = false;
function checkForToken() {
    setTimeout(() => {
        if (globalData.jwtToken) {
            getBets();
        } else if (!error) {
            checkForToken();
            networkCounter++
            if (networkCounter > waitTime) {
                setTimeout(() => {
                    setSessionExpired();
                }, 1000);
                showErrorPopup("Token expired , could not connect to server");
                gameAssets.loadingScreen.children[0].text = "CONNECTION FAILED"
                error = true
            }
        }
    }, 100);
}
async function getBets() {
    axios.defaults.headers.Authorization = `bearer ${globalData.jwtToken}`;
    // const totalBet = getTotalBet()

    // const data = {
    //     page: "1",
    //     perPage: "2",
    //     filter: ["pending"]
    // }
    // const header = { headers: { Authorization: `bearer ${globalData.jwtToken}` } }
    // axios.headers = `Bearer ${globalData.jwtToken}`;
    // await axios.get(globalData.baseUrl + 'game/lottery/jeepney/get-bets',)
    await axios.get(process.env.REACT_APP_BACKEND_URL_HTTP + '/game/lottery/tuk-tuk-gold/get-bets?page=1&perPage=2&filter=pending')
        .then((response) => {
            storeBetsData(response.data)
            //  continueWithBetResult(response.data);
        })
        .catch((error) => {
            showErrorPopup(error.response?.data.errors[0].description)
            //TODO: REMOVE THIS , ONLY FOR TESTING
            if (error.response?.data.errors[0].name == "InvalidToken" || error.response?.data.errors[0]?.fields?.message == 'jwt expired') {
                globalData.tokenExpired = true
                errorOccured(error.message)
                setTimeout(() => {
                    setSessionExpired();
                }, 1000);
            }
        });
}

function storeBetsData(data) {
    if (data.data.bets.length) {
        resumeGame(
            data.data.bets[0].maxRound,
            data.data.bets[0].roundDetails.length ? data.data.bets[0].roundDetails.length : 0,
            data.data.bets[0].betAmount,
            data.data.wallet.balance,
            data.data.bets[0].roundDetails.length ? data.data.bets[0].roundDetails[data.data.bets[0].roundDetails.length - 1].noOfHits : 0,
            data.data.bets[0].roundDetails.length ? data.data.bets[0].roundDetails[data.data.bets[0].roundDetails.length - 1].awardMulti : 0);
        if (data?.data?.jackpotDetails?.length > 0)
            handlePendingJackpotDetails(data.data.jackpotDetails)
    }
    else {
        startNewGame();
    }

}

async function handlePendingJackpotDetails(jackpotDetails) {
    const len = jackpotDetails.length
    for (let i = 0; i < len; i++) {
        if (jackpotDetails[i]?.description === "Minor") {
            globalData.jackpotMinorWin = globalData.minorFlag = true
            globalData.jackpotMinorWinAmount = jackpotDetails[i].amount
            globalData.resetMinorJackpotValue = jackpotDetails[i].jackpotBeforeTrigger

            showMinorJackpotWin(globalData.jackpotMinorWinAmount, 4)
        } else if (jackpotDetails[i]?.description === "Major") {
            globalData.jackpotMajorWin = globalData.majorFlag = true
            globalData.jackpotMajorWinAmount = jackpotDetails[i].amount
            globalData.resetMajorJackpotValue = jackpotDetails[i].jackpotBeforeTrigger
            showMajorJackpotWin(globalData.jackpotMajorWinAmount, 4)
        } else if (jackpotDetails[i]?.description === "Grand") {
            globalData.jackpotGrandWin = globalData.grandFlag = true;
            globalData.jackpotGrandWinAmount = jackpotDetails[i].amount
            globalData.resetGrandJackpotValue = jackpotDetails[i].jackpotBeforeTrigger
            showGrandJackpotWin(globalData.jackpotGrandWinAmount, 4)
        }
    }
    parseJackpotResult();
}


function resumeGame(totalRounds, currentRound, totalBet, balance, numOfWins, multiplier) {
    globalData.totalRounds = totalRounds
    globalData.currentRound = currentRound
    globalData.multiplier = multiplier
    globalData.bet = totalBet / globalData.betMultiplier
    globalData.totalBet = totalBet
    globalData.balance = balance
    globalData.numOfRoundsWon = numOfWins;
    globalData.multiplier = multiplier
    globalData.currentGameState = gameStates.ROUND_START
    //disableLoadingScreen();

    setBet(globalData.bet)
    updateTotalBet();
    updateBalance();
    setTotalRound(totalRounds)
    pendingGameUpdate();
    handleGameState(globalData.currentGameState, false)
}

function startNewGame() {
    globalData.currentGameState = gameStates.IDLE
    handleGameState(globalData.currentGameState)
    // disableLoadingScreen();
    pendingGameUpdate();
}

export async function setLanguage(lang = "en") {

    globalData.gameLanguage = lang

    const data = {
        "language": lang
    }
    try {
        const response = await axios.post(globalData.baseUrl + '/user/update-language-status', data);


    } catch (error) {
    }
}

function errorOccured(error) {
}

function getDemoGameData() {
    globalData.gameLanguage = "en"
    globalData.balance = demoData.userInfo.balance
    globalData.betSettings = demoData.betInfo.betSettings
    globalData.betSettings.sort((a, b) => a - b);
    globalData.minBet = demoData.betInfo.minBet
    globalData.betMultiplier = demoData.betInfo.betMultiplier
    globalData.maxBet = demoData.betInfo.maxBet
    globalData.isNewUser = demoData.userInfo.isNewUser
    globalData.roundSettings = demoData.roundInfo.roundSettings
    globalData.roundSettings.sort((a, b) => a - b);
    if (gameAssets?.balanceValueText?.text) gameAssets.balanceValueText.text = globalData.balance
}

function placeBetDemoGame(totalRounds, totalBet) {
    globalData.balance = placeBetSimulator(totalRounds, totalBet)
    globalData.jackpot = false;
    updateBalance();

    setTimeout(() => {
        handleGameState(globalData.currentGameState);
    }, 1000);

    // if (gameAssets?.balanceValueText?.text) gameAssets.balanceValueText.text = data.data.wallet.balance
    //  if (gameAssets.cheatMessage.text) gameAssets.cheatMessage.text = data.data.details.obstaclesDirection
}

function playGameDemo(jeepneyLane) {
    updateDemoRoundDetails(jeepneyLane)
    setTimeout(() => {

        globalData.totalRounds = demoData.sessionInfo.totalRounds
        globalData.obstacleLane = demoData.currentRoundDetails.obstacleLane
        globalData.roundWinnings = demoData.currentRoundDetails.roundWinnings
        globalData.gameResult = demoData.currentRoundDetails.gameResult
        if (globalData.roundWinnings > 0) {
            globalData.balance = demoData.userInfo.balance
            updateBalance();
        }

        globalData.multiplier = demoData.currentRoundDetails.multiplier
        globalData.winType = demoData.currentRoundDetails.winType;
        globalData.jackpot = false;
        handleGameState(globalData.currentGameState);
    }, 100);
}

export async function isOnline(timeout = 3000) {
    if (demoData.isDemo) return true;
    if (!navigator.onLine) return false; // First, check browser's built-in online status

    const loaderTimeout = setTimeout(() => {
        instances.NetworkLoader?.showLoader();
    }, 750);

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);

    try {
        const response = await fetch(process.env.REACT_APP_HEALTH_CHECK_API + '/health-check', {
            method: "GET",
            cache: "no-store",
            signal: controller.signal, // Attach the timeout
        });
        instances.NetworkLoader?.hideLoader();
        clearTimeout(timeoutId);
        clearTimeout(loaderTimeout);
        return response.ok;
    } catch (error) {
        instances.NetworkLoader?.hideLoader();
        clearTimeout(timeoutId);
        clearTimeout(loaderTimeout);
        return false; // If fetch fails or times out, assume offline
    }
    // return true
}




